import { render, staticRenderFns } from "./EmailAccounts.vue?vue&type=template&id=66fdcb55"
import script from "./EmailAccounts.vue?vue&type=script&lang=js"
export * from "./EmailAccounts.vue?vue&type=script&lang=js"
import style0 from "./EmailAccounts.vue?vue&type=style&index=0&id=66fdcb55&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fdcb55')) {
      api.createRecord('66fdcb55', component.options)
    } else {
      api.reload('66fdcb55', component.options)
    }
    module.hot.accept("./EmailAccounts.vue?vue&type=template&id=66fdcb55", function () {
      api.rerender('66fdcb55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/EmailAccounts.vue"
export default component.exports